import * as React from "react";
const SvgFiRrNose = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M8.927 12.128a1 1 0 0 1-.555 1.3c-1.216.491-4.373 2.269-4.373 4.572 0 2.78 2.78 4.03 2.897 4.082A1.002 1.002 0 0 1 6.497 24a1 1 0 0 1-.393-.081c-.167-.071-4.106-1.807-4.106-5.919s5.399-6.337 5.628-6.429a1 1 0 0 1 1.3.557zm14.072 7.312c-.021-1.424-.78-2.975-2.258-4.61-1.452-1.606-2.898-4.765-3.955-7.071l-.419-.909c-.986-2.124-1.302-3.211-1.358-5.87-.012-.552-.476-.967-1.021-.979-.552.012-.99.469-.979 1.021.063 2.975.459 4.333 1.545 6.669l.414.9c1.11 2.425 2.631 5.744 4.289 7.579 1.14 1.262 1.752 2.555 1.752 3.472 0 .007.083.777-.457 1.399-.511.589-1.488.906-2.807.944-1.162-.075-1.853-.648-2.705-1.367-.496-.42-1.008-.854-1.652-1.219-1.033-.586-1.812-.466-2.282-.259a1.9 1.9 0 0 0-.88.766c-.068.12-.282.554-.205 1.148.065.509.36 1.238 1.394 1.824 1.845 1.046 3.743 1.115 6.078 1.12.002 0 .69-.028.779-.054 1.678-.127 2.968-.645 3.791-1.593 1.024-1.182.972-2.542.936-2.912z"
    />
  </svg>
);
export default SvgFiRrNose;
